import { CustomCellRendererProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import ElementList from '../element-list/ElementList';

const getColour = (value: string): 'danger' | 'healthy' | 'information' | 'neutral' | 'warning' => {
  switch (value) {
    case 'Ready':
    case 'Applied':
      return 'healthy';

    case 'Failed':
      return 'danger';

    case 'Unknown':
      return 'warning';

    default:
      return 'neutral';
  }
};

export function ConfigStatusRenderer(params: CustomCellRendererProps): ReactElement {
  const { t } = useTranslation();

  return (
    <ElementList>
      <VdsBadgePill
        value={t(params.value)}
        size="extra-small"
        statusColor={getColour(params.value)}
      />
    </ElementList>
  );
}

export default ConfigStatusRenderer;
